import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemHelperNotificationRoute: InvariantJiraRoute = {
	name: 'global-settings-system-helper-notification',
	path: '/secure/admin/NotificationHelperAdmin.jspa',
};
